import { useEffect } from "react";

const SITE = "https://ogstay.com";

const setMeta = (selector, value) => {
  const el = document.querySelector(selector);
  const prev = el?.getAttribute("content");
  if (el && value) el.setAttribute("content", value);
  return () => {
    if (el && prev) el.setAttribute("content", prev);
  };
};

export function useSEO(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href");
    const url = `${SITE}${window.location.pathname}`;
    if (canonical) canonical.setAttribute("href", url);

    const restore = [
      setMeta('meta[name="description"]', description),
      setMeta('meta[property="og:title"]', title),
      setMeta('meta[property="og:description"]', description),
      setMeta('meta[property="og:url"]', url),
      setMeta('meta[name="twitter:title"]', title),
      setMeta('meta[name="twitter:description"]', description),
    ];

    return () => {
      document.title = prevTitle;
      if (canonical && prevCanonical) canonical.setAttribute("href", prevCanonical);
      restore.forEach((fn) => fn());
    };
  }, [title, description]);
}
